/**
 * Compact relative-time formatter.
 * Examples: "Today", "Yesterday", "3 days ago", "2 months ago", "1 year ago".
 */
export const formatRelativeDate = (iso, now = new Date()) => {
    const then = new Date(iso);
    const diffMs = now.getTime() - then.getTime();
    const days = Math.floor(diffMs / (24 * 60 * 60 * 1000));
    if (days < 0)
        return 'Just now';
    if (days === 0)
        return 'Today';
    if (days === 1)
        return 'Yesterday';
    if (days < 30)
        return `${days} days ago`;
    const months = Math.floor(days / 30);
    if (months < 12)
        return months === 1 ? '1 month ago' : `${months} months ago`;
    const years = Math.floor(days / 365);
    return years === 1 ? '1 year ago' : `${years} years ago`;
};
